import reducer, { initglobalStore } from './reducer/Reducer'
import createStore from './react-store'

const load = createStore(reducer, initglobalStore)

export default load
